import { Stack, Tooltip, Typography } from "@mui/material";
import UnreviewableIcon from "@/Washouts/assets/icons/components/UnreviewableIcon";
import ReviewedIcon from "@/Washouts/assets/icons/components/ReviewedIcon";
import NoPayPlanIcon from "@/Washouts/assets/icons/squareBlue.svg";
import NoWashoutIcon from "@/Washouts/assets/icons/squareGray.svg";
import FailWashoutIcon from "@/Washouts/assets/icons/squareRed.svg";
import ApprovedWashoutIcon from "@/Washouts/assets/icons/approvedCheckGreen.svg";
import clsx from "clsx";
import { StatusKey } from "@/Washouts/helpers/Statuses";

export type TPositionTreeIconProps = {
	iconKey?: string | null;
	tooltip?: string;
	selected?: boolean;
};

interface TreeIconProps {
	classes?: string;
	icon?: string | null;
	sx?: object;
	disabled?: boolean;
	selected?: boolean;
	iconKey?: string;
}

const chooseIcon = (iconKey: string | null, selected: boolean) => {
	if (!iconKey) {
		return null;
	}

	const iconMap: Record<string, JSX.Element | null> = {
		[StatusKey.NoPayPlan]: <TreeIcon icon={NoPayPlanIcon} selected={selected} />,
		[StatusKey.NoPayPlanSigned]: <TreeIcon icon={NoPayPlanIcon} selected={selected} />,
		[StatusKey.NoWashout]: <TreeIcon icon={NoWashoutIcon} selected={selected} />,
		[StatusKey.FailWashout]: <TreeIcon icon={FailWashoutIcon} selected={selected} />,
		[StatusKey.ApprovedWashout]: <TreeIcon icon={ApprovedWashoutIcon} selected={selected} />,
		[StatusKey.RetractWashout]: <TreeIcon icon={ApprovedWashoutIcon} selected={selected} iconKey={StatusKey.RetractWashout} />,
		[StatusKey.Reviewed]: <ReviewedIcon sx={{ marginBottom: "-12px", marginRight: "-8px", minWidth: "16px", minHeight: "16px" }} />,
		[StatusKey.UnReviewable]: (
			<UnreviewableIcon sx={{ marginBottom: "-5px", marginRight: "-2px", minWidth: "16px", minHeight: "16px" }} />
		),
	};

	return iconMap[iconKey] ?? null;
};

export const TreeIcon = (props: TreeIconProps) => {
	const { classes = "", sx = { minWidth: 16, minHeight: 16 }, icon = null, disabled = false, selected, iconKey } = props;
	if (!icon) {
		return null;
	}
	return (
		<img
			style={{ marginBottom: "0px", marginRight: "-1px", ...sx }}
			src={!selected ? (!iconKey ? icon : "") : ""}
			className={clsx({
				["bg-disabled"]: disabled,
				[classes]: Boolean(classes),
			})}
		/>
	);
};

const PositionTreeIcon = (props: TPositionTreeIconProps) => {
	const { iconKey = null, tooltip = "", selected = false } = props;
	const hasTooltip = Boolean(tooltip?.length);

	if (!hasTooltip || selected) {
		return <Stack>{chooseIcon(iconKey, selected)}</Stack>;
	}

	return (
		<Tooltip
			placement="bottom"
			arrow
			title={
				<Typography className="!font-sans !text-[12px]" component="span">
					{tooltip}
				</Typography>
			}
		>
			<Stack>{chooseIcon(iconKey, selected)}</Stack>
		</Tooltip>
	);
};
export default PositionTreeIcon;
